import { defineComponent } from "vue";
import * as Push from "push.js";
import { ETypeNotification, INotification, IConfigNotification } from "@/interfaces/i-notification";
import { EventBus } from "@/utils/event-bus";

export default defineComponent({
  name: "sdk-notification",
  data() {
    return {
      activeWindow: true,
      unsubBlur: {} as any,
      unsubFocus: {} as any,
    };
  },
  computed: {
    notificationSupport(): boolean {
      return "Notification" in window;
    },
    notificationPermission(): boolean {
      return this.notificationSupport && ((Notification as any).permission !== "denied" || (Notification as any).permission === "default");
    },
    useNotification(): boolean {
      return this.notificationSupport && this.notificationPermission && !this.activeWindow;
    },
  },
  methods: {
    defaultType(): IConfigNotification {
      return {
        icon: "static/img/notification/detalhes.png",
        type: "default",
      };
    },
    sucessType(): IConfigNotification {
      return {
        icon: "static/img/notification/confirmar.png",
        type: "success",
      };
    },
    warningType(): IConfigNotification {
      return {
        icon: "static/img/notification/alerta.png",
        type: "warning",
      };
    },
    dangerType(): IConfigNotification {
      return {
        icon: "static/img/notification/erro.png",
        type: "error",
        duration: 5000,
      };
    },
    infoType(): IConfigNotification {
      return {
        icon: "static/img/notification/detalhes.png",
        type: "info",
      };
    },
    blurHandler() {
      this.activeWindow = false;
    },
    focusHandler() {
      this.activeWindow = true;
    },
  },
  created() {
    EventBus.$on("emmit-notification", (notif: any) => {
      let selectedType;

      switch (notif.type) {
        case ETypeNotification.SUCCESS:
          selectedType = this.sucessType();
          break;
        case ETypeNotification.WARNING:
          selectedType = this.warningType();
          break;
        case ETypeNotification.DANGER:
          selectedType = this.dangerType();
          break;
        case ETypeNotification.INFO:
          selectedType = this.infoType();
          break;

        default:
          selectedType = this.defaultType();
      }

      if (notif.type === ETypeNotification.DANGER) {
        selectedType = this.dangerType();
      }
      delete notif.type;
      const config: INotification = Object.assign({}, selectedType, notif);

      if (this.useNotification) {
        (Push as any).create(config.title, {
          duration: config.duration,
          body: config.message,
          icon: config.icon,
          timeout: config.duration,
        });
      } else {
        this.$notify({
          group: "appNotifications",
          title: config.title,
          text: config.message,
          type: config.type,
          duration: config.duration,
        } as any);
      }
    });
  },
  mounted() {
    this.unsubBlur = this.blurHandler.bind(this);
    this.unsubFocus = this.focusHandler.bind(this);
    window.addEventListener("blur", this.unsubBlur);
    window.addEventListener("focus", this.unsubFocus);
  },
  destroyed() {
    EventBus.$off("emmit-notification");
    window.removeEventListener("blur", this.unsubBlur, false);
    window.removeEventListener("focus", this.unsubFocus, false);
  },
});
